import React from 'react'
import { Link } from 'react-router-dom';

import { AccountsData } from './Components/AccountData'
import { LastTransactionData, MyCard } from './Components/LastTransactionData'
import { creditDebitChart } from './Components/AccountOverviewChart';
import { invoicesData } from './Components/InvoicesData';
import CountUp from 'react-countup';
import Chart from "react-apexcharts";

const Accounts = () => {
    return (
        <div className='pb-[5rem]'>
            {/* // x---------------------------------x Accounts Card Section // x---------------------------------x */}
            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4  gap-4">
                {AccountsData.map((data, index) => (
                    <div key={index}>
                        <div className="card border-0 bg-transparent h-full">
                            <div className="card-body rounded-2xl bg-white p-4">
                                <div className="flex items-center">
                                    <div
                                        className={`card-img w-16 h-16 rounded-full mr-4 flex items-center justify-center ${data.icon_bg}`}
                                    >
                                        {data.icon}
                                    </div>
                                    <div className="card-text">
                                        <p className="text-dark opacity-50 m-0">{data.title}</p>
                                        <p className="text-dark font-semibold m-0">${data.amount}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {/* // x---------------------------------x Last Transaction/MyCards Section // x---------------------------------x */}
            <div className="grid grid-cols-1 xl:grid-cols-3 gap-6 mt-3">
                {/* // x---------------------------------x Last Transaction Section // x---------------------------------x */}
                <div className="col-span-1 xl:col-span-2">
                    <div className="card border-0 bg-transparent h-full">
                        <div className="card-header">
                            <h3 className="text-dark sm:text-2xl font-semibold p-3">Last Transaction</h3>
                        </div>
                        <div className="card-body rounded-2xl bg-white">
                            <ul className="list-none space-y-3 mb-0 p-3" id="MyClients">
                                {LastTransactionData.map((data, index) => (
                                    <li key={index}>
                                        <div className="bg-light p-4 rounded-2xl">
                                            <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-6">
                                                {/* Transaction Info */}
                                                <div className="flex items-center gap-4">
                                                    <div
                                                        className={`card-img w-14 h-14 rounded-full flex items-center justify-center ${data.icon_bg}`}
                                                    >
                                                        {data.icon}
                                                    </div>
                                                    <div>
                                                        <p className="mb-1 font-bold text-dark">{data.transactionTitle}</p>
                                                        <span className="text-dark opacity-50">{data.transactionDate}</span>
                                                    </div>
                                                </div>
                                                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-dark">
                                                    <h6>{data.transactionType}</h6>
                                                    <h6>{data.cardNumber}</h6>
                                                    <h6>{data.PaymentStatus}</h6>
                                                    <h6 className={data.text_color}>{data.accountAmount}</h6>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
                {/* // x---------------------------------x My Cards Section // x---------------------------------x */}
                <div className="col-span-1">
                    <div className="card border-0 bg-transparent h-full">
                        <div className="card-header flex justify-between items-center">
                            <h3 className="text-dark sm:text-2xl font-semibold p-3">My Cards</h3>
                            <Link to="/" className="text-primary sm:text-2xl font-semibold p-3">See All</Link>
                        </div>
                        {MyCard.map((myCard, index) => (
                            <div key={index}>
                                <div className={`${myCard.id === 0 ? myCard.bg_color : "card-body"} rounded-2xl shadow-md overflow-hidden`}>
                                    <div className="mb-3">
                                        <div className={`p-4 ${myCard.text_color}`}>
                                            <div className="flex justify-between items-center">
                                                <div>
                                                    <h5 className="text-base sm:text-lg font-normal">Balance</h5>
                                                    <h4 className={`text-2xl font-bold ${myCard.text_color}`}>
                                                        $ <CountUp
                                                            className={`${myCard.text_color}`}
                                                            end={myCard.value}
                                                            duration={2}
                                                        />
                                                    </h4>

                                                </div>
                                                <div className="card-img">{myCard.cardIcon}</div>
                                            </div>
                                            <div className="flex justify-between items-center py-4 sm:py-5 md:py-6">
                                                <div>
                                                    <h5 className="text-base sm:text-lg font-normal mb-1">CARD HOLDER</h5>
                                                    <h4 className={`text-2xl font-bold ${myCard.text_color}`}>{myCard.name}</h4>
                                                </div>
                                                <div>
                                                    <h5 className="text-base sm:text-lg font-normal mb-1 text-opacity-75">VALID THRU</h5>
                                                    <h4 className={`text-2xl font-bold ${myCard.text_color}`}>{myCard.expiry}</h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`border-t border-dashed border-${myCard.borderColor} px-4 sm:px-6 md:px-8 mt-5`}>
                                            <div className="flex justify-between items-center py-2 sm:py-3 md:py-4">
                                                <div>
                                                    <h4 className={`text-2xl lg:text-2xl font-bold ${myCard.text_color}`}>{myCard.cardNumber}</h4>
                                                </div>
                                                <div>{myCard.f_icon}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* // x---------------------------------x Debit & Credit Overview/Invoices Sent Section // x---------------------------------x */}
            <div className="grid grid-cols-1 2xl:grid-cols-3 gap-6 mt-3">
                {/* // x---------------------------------x Debit & Credit Overview Section // x---------------------------------x */}
                <div className="col-span-1 xl:col-span-2">
                    <div className="card border-0 bg-transparent h-full">
                        <div className="card-header flex justify-between items-center">
                            <h3 className="text-dark sm:text-2xl font-semibold p-3">Debit &amp; Credit Overview</h3>
                        </div>
                        <div className="card-body p-0 bg-white rounded-2xl h-full items-center flex">
                            <div id="chart-one" className='w-full text-dark'>
                                <Chart
                                    options={creditDebitChart}
                                    series={creditDebitChart.series}
                                    type={creditDebitChart.chart.type}
                                    height={creditDebitChart.chart.height}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* // x---------------------------------x Invoices Sent Section // x---------------------------------x */}
                <div className="card border-0 bg-transparent h-full mt-7 sm:mt-10 2xl:mt-0">
                    <div className="card-header flex justify-between items-center">
                        <h3 className="text-dark  sm:text-2xl font-semibold p-3">Invoices Sent</h3>
                    </div>
                    <div className="card-body bg-white rounded-2xl h-full">
                        <div className="flex flex-col justify-around h-full">
                            {invoicesData.map((data, index) => (
                                <div className="flex justify-between items-center px-4" key={index}>
                                    <div className="flex items-center gap-3">
                                        <div className={`card-img w-16 h-16 rounded-full flex items-center justify-center ${data.icon_Bg}`}>
                                            {data.icon}
                                        </div>
                                        <div>
                                            <p className="text-gray-600 text-lg sm:text-xl">{data.heading}</p>
                                            <p className="text-dark text-base">{data.time}</p>
                                        </div>
                                    </div>
                                    <p className="text-right text-dark text-base">${data.amount}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Accounts
